// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    DebitCardActivateDebitCardActivateDebitCardResponse,
    DebitCardDebitCardGetDebitCardDetailDefaultResponse,
    DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse,
    DebitCardGetDebitCardDetailGetDebitCardDetailRequestModel,
    DebitCardGetDebitCardMapDebitCardMapsResponse,
    DebitCardGetDebitCardPinDebitCardPinResponse,
    DebitCardMapRequestModel,
    DebitCardRequestModel,
    DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel,
    DebitCardV2DebitCardV2DebitCardDetailDefaultResponse,
    DebitCardV2DebitCardV2VdcLookupDefaultResponse,
    DebitCardV2SecuredGetDebitCardDetailResponseModel,
    DebitCardVmcEncryptedPciInfoResponseModel,
    GatewayError,
    GetLashPatientDebitCardLast4RequestModel,
    VdcLookupRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeDebitCardApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param debitCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async activateDebitCardActivateDebitCard (debitCardRequestModel: DebitCardRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardActivateDebitCardActivateDebitCardResponse>> {
        const _url_ = '/edge/debitCard/ActivateDebitCard/ActivateDebitCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardRequestModel' is not null or undefined
        if (debitCardRequestModel === null || debitCardRequestModel === undefined) {
            throw new Error('Required parameter debitCardRequestModel was null or undefined when calling activateDebitCardActivateDebitCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardRequestModel, "DebitCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardActivateDebitCardActivateDebitCardResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardActivateDebitCardActivateDebitCardResponse");
        }
        return response;
    }
    /**
     * 
     * @param debitCardGetDebitCardDetailGetDebitCardDetailRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardGetDebitCardDetail (debitCardGetDebitCardDetailGetDebitCardDetailRequestModel: DebitCardGetDebitCardDetailGetDebitCardDetailRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardDebitCardGetDebitCardDetailDefaultResponse>> {
        const _url_ = '/edge/debitCard/GetDebitCardDetail';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardGetDebitCardDetailGetDebitCardDetailRequestModel' is not null or undefined
        if (debitCardGetDebitCardDetailGetDebitCardDetailRequestModel === null || debitCardGetDebitCardDetailGetDebitCardDetailRequestModel === undefined) {
            throw new Error('Required parameter debitCardGetDebitCardDetailGetDebitCardDetailRequestModel was null or undefined when calling debitCardGetDebitCardDetail.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardGetDebitCardDetailGetDebitCardDetailRequestModel, "DebitCardGetDebitCardDetailGetDebitCardDetailRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardDebitCardGetDebitCardDetailDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardDebitCardGetDebitCardDetailDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getLashPatientDebitCardLast4RequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardGetLashPatientDebitCardLast4 (getLashPatientDebitCardLast4RequestModel: GetLashPatientDebitCardLast4RequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse>> {
        const _url_ = '/edge/debitCard/GetLashPatientDebitCardLast4';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getLashPatientDebitCardLast4RequestModel' is not null or undefined
        if (getLashPatientDebitCardLast4RequestModel === null || getLashPatientDebitCardLast4RequestModel === undefined) {
            throw new Error('Required parameter getLashPatientDebitCardLast4RequestModel was null or undefined when calling debitCardGetLashPatientDebitCardLast4.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getLashPatientDebitCardLast4RequestModel, "GetLashPatientDebitCardLast4RequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param debitCardMapRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardMapDebitCardMaps (debitCardMapRequestModel: DebitCardMapRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardGetDebitCardMapDebitCardMapsResponse>> {
        const _url_ = '/edge/debitCard/GetDebitCardMap/DebitCardMaps';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardMapRequestModel' is not null or undefined
        if (debitCardMapRequestModel === null || debitCardMapRequestModel === undefined) {
            throw new Error('Required parameter debitCardMapRequestModel was null or undefined when calling debitCardMapDebitCardMaps.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardMapRequestModel, "DebitCardMapRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardGetDebitCardMapDebitCardMapsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardGetDebitCardMapDebitCardMapsResponse");
        }
        return response;
    }
    /**
     * 
     * @param debitCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardPinDebitCardPin (debitCardRequestModel: DebitCardRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardGetDebitCardPinDebitCardPinResponse>> {
        const _url_ = '/edge/debitCard/GetDebitCardPin/DebitCardPin';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardRequestModel' is not null or undefined
        if (debitCardRequestModel === null || debitCardRequestModel === undefined) {
            throw new Error('Required parameter debitCardRequestModel was null or undefined when calling debitCardPinDebitCardPin.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardRequestModel, "DebitCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardGetDebitCardPinDebitCardPinResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardGetDebitCardPinDebitCardPinResponse");
        }
        return response;
    }
    /**
     * 
     * @param debitCardV2DebitCardDetailGetDebitCardDetailRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardV2DebitCardDetail (debitCardV2DebitCardDetailGetDebitCardDetailRequestModel: DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardV2DebitCardV2DebitCardDetailDefaultResponse>> {
        const _url_ = '/edge/debitCard/v2/DebitCardDetail';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardV2DebitCardDetailGetDebitCardDetailRequestModel' is not null or undefined
        if (debitCardV2DebitCardDetailGetDebitCardDetailRequestModel === null || debitCardV2DebitCardDetailGetDebitCardDetailRequestModel === undefined) {
            throw new Error('Required parameter debitCardV2DebitCardDetailGetDebitCardDetailRequestModel was null or undefined when calling debitCardV2DebitCardDetail.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardV2DebitCardDetailGetDebitCardDetailRequestModel, "DebitCardV2DebitCardDetailGetDebitCardDetailRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardV2DebitCardV2DebitCardDetailDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardV2DebitCardV2DebitCardDetailDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param vdcLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async debitCardV2VdcLookup (vdcLookupRequestModel: VdcLookupRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardV2DebitCardV2VdcLookupDefaultResponse>> {
        const _url_ = '/edge/debitCard/v2/VdcLookup';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'vdcLookupRequestModel' is not null or undefined
        if (vdcLookupRequestModel === null || vdcLookupRequestModel === undefined) {
            throw new Error('Required parameter vdcLookupRequestModel was null or undefined when calling debitCardV2VdcLookup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(vdcLookupRequestModel, "VdcLookupRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardV2DebitCardV2VdcLookupDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardV2DebitCardV2VdcLookupDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param debitCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async securedDebitCardDetail (debitCardRequestModel: DebitCardRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardV2SecuredGetDebitCardDetailResponseModel>> {
        const _url_ = '/edge/debitCard/v2/Secured/DebitCardDetail';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardRequestModel' is not null or undefined
        if (debitCardRequestModel === null || debitCardRequestModel === undefined) {
            throw new Error('Required parameter debitCardRequestModel was null or undefined when calling securedDebitCardDetail.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardRequestModel, "DebitCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardV2SecuredGetDebitCardDetailResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardV2SecuredGetDebitCardDetailResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param debitCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async securedGetDebitCardDetail (debitCardRequestModel: DebitCardRequestModel, xProgramId?: string): Promise<AxiosResponse<DebitCardVmcEncryptedPciInfoResponseModel>> {
        const _url_ = '/edge/debitCard/Secured/GetDebitCardDetail';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'debitCardRequestModel' is not null or undefined
        if (debitCardRequestModel === null || debitCardRequestModel === undefined) {
            throw new Error('Required parameter debitCardRequestModel was null or undefined when calling securedGetDebitCardDetail.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(debitCardRequestModel, "DebitCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DebitCardVmcEncryptedPciInfoResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardVmcEncryptedPciInfoResponseModel");
        }
        return response;
    }
}
